import React from "react";
import { Card, CardBody, CardHeader } from "reactstrap";

/**
 * Reusable section card with optional header icon, title, subtitle, and
 * right-side action slot. Used for grouping related content within a
 * page (e.g. "Job Details", "Inspection Setup", "Operation Selection").
 *
 * Stays inside the theme — uses Card/CardHeader/CardBody from Reactstrap
 * with the dashboard's standard shadow-sm + border-0 conventions.
 */
const SectionCard = ({
  icon,
  title,
  subtitle,
  actions,
  children,
  className = "",
  bodyClassName = "",
  noPadding = false,
}) => {
  return (
    <Card className={`shadow-sm border-0 ${className}`}>
      {title || actions || icon ? (
        <CardHeader className="bg-white border-0 pt-3 px-3 pb-2">
          <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
            <div className="d-flex align-items-center gap-2" style={{ minWidth: 0 }}>
              {icon ? (
                <span
                  className="d-inline-flex align-items-center justify-content-center"
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: 8,
                    background: "rgba(64, 81, 137, 0.1)",
                    color: "var(--ssw-ink-blue, #405189)",
                    flexShrink: 0,
                  }}
                >
                  <i className={icon} style={{ fontSize: 16 }} />
                </span>
              ) : null}
              <div style={{ minWidth: 0 }}>
                {title ? (
                  <h6 className="fw-semibold mb-0" style={{ color: "var(--ssw-text-1, #212529)" }}>
                    {title}
                  </h6>
                ) : null}
                {subtitle ? (
                  <p className="text-muted small mb-0" style={{ fontSize: 12 }}>
                    {subtitle}
                  </p>
                ) : null}
              </div>
            </div>
            {actions ? (
              <div className="d-flex align-items-center gap-2">{actions}</div>
            ) : null}
          </div>
        </CardHeader>
      ) : null}
      <CardBody className={`${noPadding ? "p-0" : ""} ${bodyClassName}`}>
        {children}
      </CardBody>
    </Card>
  );
};

export default SectionCard;
